// --- AURA X ENGINE : INITIALIZATION ---
// Core: GSAP (Animations), Canvas 2D (Atmosphere)

// Integrate with GSAP ScrollTrigger
if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
} else {
    console.warn("ScrollTrigger not loaded");
}

// 2. AURA ATMOSPHERE (Canvas Background)
// A subtle, living particle system to give depth to the "Void" or "Light"
const canvas = document.getElementById('webgl-canvas');
if (canvas) {
    const ctx = canvas.getContext('2d');
    let width, height;
    let particles = [];

    // Configuration
    const particleCount = 40; // Low count for subtle elegance
    const connectionDistance = 0; // No lines, just floating orbs
    const moveSpeed = 0.2;

    class Particle {
        constructor() {
            this.x = Math.random() * width;
            this.y = Math.random() * height;
            this.vx = (Math.random() - 0.5) * moveSpeed;
            this.vy = (Math.random() - 0.5) * moveSpeed;
            this.size = Math.random() * 80 + 20; // Large, soft blobs
            // Colors: Mint and Coral hints, mostly transparent
            this.hue = Math.random() > 0.5 ? 150 : 350; // Greenish or Reddish
        }

        update() {
            this.x += this.vx;
            this.y += this.vy;

            // Bounce off edges
            if (this.x < -100 || this.x > width + 100) this.vx *= -1;
            if (this.y < -100 || this.y > height + 100) this.vy *= -1;
        }

        draw() {
            ctx.beginPath();
            // Soft Gradient Blob
            const gradient = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.size);
            // Light Mode Colors: Very faint
            if (this.hue === 150) {
                gradient.addColorStop(0, "rgba(16, 185, 129, 0.03)"); // Mint
            } else {
                gradient.addColorStop(0, "rgba(255, 107, 107, 0.03)"); // Coral
            }
            gradient.addColorStop(1, "rgba(255,255,255,0)");

            ctx.fillStyle = gradient;
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fill();
        }
    }

    function initCanvas() {
        width = window.innerWidth;
        height = window.innerHeight;
        canvas.width = width;
        canvas.height = height;
        particles = [];
        for (let i = 0; i < particleCount; i++) {
            particles.push(new Particle());
        }
    }

    function animateCanvas() {
        ctx.clearRect(0, 0, width, height);
        particles.forEach(p => {
            p.update();
            p.draw();
        });
        requestAnimationFrame(animateCanvas);
    }

    window.addEventListener('resize', initCanvas);
    initCanvas();
    animateCanvas();
}


// 3. GSAP ANIMATION CHOREOGRAPHY

// A. Hero Sequence (Entrance)
const heroTl = gsap.timeline({ defaults: { ease: "power3.out" } });

// Check if we are on the homepage (or page with hero-title-expert)
if (document.querySelector(".hero-title-expert")) {
    heroTl
        .from(".hero-title-expert .word-nutrition, .hero-title-expert .word-heureuse", {
            y: 100,
            opacity: 0,
            duration: 1.2,
            stagger: 0.15,
            delay: 0.2
        })
        .from(".hero-intro-wrapper", {
            y: 20,
            opacity: 0,
            duration: 1
        }, "-=0.8")
        .from(".hero-subtitle", {
            y: 20,
            opacity: 0,
            duration: 1
        }, "-=0.8")
        .from(".hero-actions-expert", {
            y: 20,
            opacity: 0,
            duration: 1
        }, "-=0.8")
        .from(".hero-visual-expert", {
            scale: 0.9,
            opacity: 0,
            rotation: 2,
            duration: 1.5,
            ease: "expo.out"
        }, "-=1.2")
        .from(".d-stomach-hero", { // Start floating
            opacity: 0,
            duration: 2
        }, "-=1");
}

// B. Scroll Reveals (General)
const revealElements = document.querySelectorAll(".section-header-center, .about-container, .faq-container, .big-cta-section");

revealElements.forEach(section => {
    gsap.from(section, {
        scrollTrigger: {
            trigger: section,
            start: "top 85%",
            toggleActions: "play none none reverse"
        },
        y: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.out"
    });
});

// Consultation Page Specifics
if (document.querySelector('.consultation-details')) {
    // Info Cards Stagger (If grid still exists for other reasons, else this could be removed/updated)
    if (document.querySelector(".info-card")) {
        gsap.from(".info-card", {
            scrollTrigger: {
                trigger: ".info-cards-grid",
                start: "top 80%",
            },
            y: 30,
            opacity: 0,
            duration: 0.8,
            stagger: 0.2,
            ease: "power2.out"
        });
    }

    // Consultation Tabs Logic
    const consultationTabsContainer = document.querySelector(".consultation-tabs-nav");
    const tabBtns = document.querySelectorAll(".consultation-tabs-nav .tab-btn");
    const tabPanels = document.querySelectorAll(".tab-panel");
    const tabMobileSelect = document.querySelector(".tab-mobile-select");
    const consultationGlider = document.querySelector(".consultation-tabs-nav .glider");

    if (consultationTabsContainer && tabBtns.length > 0) {
        const updateConsultationGlider = (btn) => {
            if (!consultationGlider) return;
            consultationGlider.style.width = `${btn.offsetWidth}px`;
            consultationGlider.style.left = `${btn.offsetLeft}px`;
        };

        tabBtns.forEach(btn => {
            btn.addEventListener("click", () => {
                const target = btn.getAttribute("data-tab");

                // Update Buttons
                tabBtns.forEach(b => b.classList.remove("active"));
                btn.classList.add("active");
                updateConsultationGlider(btn);

                // Update Panels
                tabPanels.forEach(panel => {
                    panel.classList.remove("active");
                    if (panel.id === target) {
                        panel.classList.add("active");
                    }
                });
                
                // Sync mobile select if it exists
                if (tabMobileSelect && tabMobileSelect.value !== target) {
                    tabMobileSelect.value = target;
                }

                // Scroll to the anchor above the tabs
                const scrollAnchor = document.getElementById('consultation-scroll-anchor');
                if (scrollAnchor) {
                    scrollAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }

                // Trigger Refresh for ScrollTrigger just in case height changes
                if (typeof ScrollTrigger !== 'undefined') {
                    ScrollTrigger.refresh();
                }
            });
        });

        // Initialize Option
        const activeConsultationBtn = document.querySelector(".consultation-tabs-nav .tab-btn.active") || tabBtns[0];
        updateConsultationGlider(activeConsultationBtn);

        // Update on resize or font load
        window.addEventListener('resize', () => {
            const activeBtn = document.querySelector(".consultation-tabs-nav .tab-btn.active");
            if (activeBtn) updateConsultationGlider(activeBtn);
        });

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                const activeBtn = document.querySelector(".consultation-tabs-nav .tab-btn.active");
                if (activeBtn) updateConsultationGlider(activeBtn);
            });
        }
    }
    
    // Mobile Select Event Listener
    if (tabMobileSelect) {
        tabMobileSelect.addEventListener("change", (e) => {
            const target = e.target.value;
            const targetBtn = Array.from(tabBtns).find(btn => btn.getAttribute("data-tab") === target);
            if (targetBtn) {
                targetBtn.click();
            }
        });
    }

    // Kept MutationObserver definition but without Lenis specific fix
    const observer = new MutationObserver((mutations) => {
        // Obsolete lenis block
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // ----------------------------------------------------------------
    // Sticky Consultation Bar: visibility + price sync
    // ----------------------------------------------------------------
    const consultationHero = document.querySelector('.consultation-hero');
    const consultationStickyBar = document.getElementById('consultationStickyBar');
    const stickyConsultationName = document.getElementById('stickyConsultationName');
    const stickyConsultationPrice = document.getElementById('stickyConsultationPrice');
    const stickyConsultationButton = document.getElementById('stickyConsultationButton');

    // Sync price/title from the currently active panel's booking card
    function syncStickyBarFromActiveTab() {
        if (!consultationStickyBar) return;
        const activePanel = document.querySelector('.tab-panel.active');
        if (!activePanel) return;
        
        const priceEl = activePanel.querySelector('.card-price');
        const targetId = activePanel.getAttribute('id');
        
        // Update body data attribute for dynamic theming
        document.body.setAttribute('data-consultation-tab', targetId);
        
        // Determine title based on panel ID
        let title = "Consultation";
        if (targetId === "premiere") title = "Première Consultation";
        else if (targetId === "suivi") title = "Consultation de Suivi"; // Fixed from Suivi to match design
        else if (targetId === "forfait") title = "Forfait Accompagnement";
        
        if (stickyConsultationName) {
            stickyConsultationName.textContent = title;
        }
        
        if (priceEl && stickyConsultationPrice) {
            stickyConsultationPrice.textContent = priceEl.textContent.trim();
        }

        // Sync handle for the modal
        const btnInPanel = activePanel.querySelector('.opener-modal');
        if (btnInPanel && stickyConsultationButton) {
            const handle = btnInPanel.getAttribute('data-handle');
            if (handle) {
                stickyConsultationButton.setAttribute('data-handle', handle);
            }
        }
    }

    // Wire the portal button to open the booking modal  
    if (stickyConsultationButton) {
        stickyConsultationButton.addEventListener('click', (e) => {
            e.preventDefault();
            const bookingModal = document.getElementById('bookingModal');
            if (bookingModal) bookingModal.style.display = 'flex';
        });
    }

    // Sync initial state
    syncStickyBarFromActiveTab();

    // Re-sync whenever a tab changes by watching for class changes on panels
    const tabSyncPanels = document.querySelectorAll('.tab-panel');
    if (tabSyncPanels.length > 0) {
        const tabSyncObserver = new MutationObserver(() => syncStickyBarFromActiveTab());
        tabSyncPanels.forEach(panel => {
            tabSyncObserver.observe(panel, { attributes: true, attributeFilter: ['class'] });
        });
    }

    // Show/hide the sticky bar based on hero scroll position.
    if (consultationHero && consultationStickyBar) {
        // App starts hidden
        consultationStickyBar.classList.remove('visible');
        
        function checkHeroVisibility() {
            const heroRect = consultationHero.getBoundingClientRect();
            // Show bar when hero's bottom reaches the middle of the viewport
            if (heroRect.bottom <= window.innerHeight * 0.5) {
                consultationStickyBar.classList.add('visible');
            } else {
                consultationStickyBar.classList.remove('visible');
            }
        }
        window.addEventListener('scroll', checkHeroVisibility, { passive: true });
        // Deferred check after first paint 
        requestAnimationFrame(() => requestAnimationFrame(checkHeroVisibility));
    }
}

// C. Decoration Parallax (Saucissons & Organs)
gsap.utils.toArray(".bg-doodle:not(.d-brain-unique)").forEach((doodle, i) => {
    gsap.to(doodle, {
        y: -50 * (i + 1), // Move up at different speeds
        scrollTrigger: {
            trigger: doodle.parentElement || "body",
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });
});

// Saucisson Bubble Scroll Trigger (Mobile Interaction)
// Saucisson Bubble Scroll Trigger (Mobile Interaction Only)
if (document.querySelector('.saucisson-wrapper')) {
    ScrollTrigger.matchMedia({
        // Mobile only
        "(max-width: 768px)": function () {
            ScrollTrigger.create({
                trigger: ".saucisson-wrapper",
                start: "top 70%", // Triggers when element is near center of viewport
                onEnter: () => {
                    const bubble = document.querySelector('.speech-bubble');
                    if (bubble) bubble.classList.add('visible');
                },
                onLeaveBack: () => {
                    const bubble = document.querySelector('.speech-bubble');
                    if (bubble) bubble.classList.remove('visible');
                }
            });
        }
    });
}


// D. Services Cards: "Handwriting" Effect (Typewriter)
if (document.querySelector(".handwriting")) {
    const texts = document.querySelectorAll(".handwriting");

    texts.forEach((el, index) => {
        // 1. Split text into characters (manual implementation)
        const content = el.innerText;
        el.innerHTML = ""; // Clear content

        // Wrap each char in a span
        content.split("").forEach(char => {
            const span = document.createElement("span");
            span.innerText = char;
            span.style.opacity = "0"; // Start hidden
            el.appendChild(span);
        });

        // 2. Animate Staggered Opacity
        gsap.to(el.children, {
            scrollTrigger: {
                trigger: el.closest('.sticky-note'), // Trigger when the note appears
                start: "top 70%", // Triggers slightly earlier
                toggleActions: "play none none reverse"
            },
            opacity: 1,
            duration: 0.03, // Faster appear per char (was 0.05)
            stagger: 0.01,  // Faster writing speed (was 0.02)
            ease: "none",
            delay: index * 0.2 // Reduced delay between cards (was 0.5)
        });
    });
}

// 15. GLOBAL NAVIGATION LOGIC (Scroll & Mobile Menu)
document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('.nav');
    const mobileToggle = document.querySelector('.nav-mobile-toggle');
    const navLinks = document.querySelector('.nav-links');

    // Scroll Effect
    const handleScroll = () => {
        if (window.scrollY > 50) {
            nav?.classList.add('scrolled');
        } else {
            nav?.classList.remove('scrolled');
        }
        if (nav) {
            document.documentElement.style.setProperty('--header-height', `${nav.offsetHeight - 1}px`); // -1px to avoid visual gaps with borders
        }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check

    // Mobile Menu Toggle
    if (mobileToggle && nav) {
        mobileToggle.addEventListener('click', () => {
            nav.classList.toggle('nav-open');
            document.body.style.overflow = nav.classList.contains('nav-open') ? 'hidden' : '';
        });
    }

    // Close menu on link click
    const links = document.querySelectorAll('.nav-link');
    links.forEach(link => {
        link.addEventListener('click', () => {
            if (nav?.classList.contains('nav-open')) {
                nav.classList.remove('nav-open');
                document.body.style.overflow = '';
            }
        });
    });
});
// 3D Tilt Removed to avoid conflicts

// 4. INTERACTIVE COMPONENTS

// Magnetic Buttons
const magButtons = document.querySelectorAll(".btn-primary, .nav-cta, .btn-secondary, .btn-magnetic, .btn-primary-expert, .btn-ghost-expert");
magButtons.forEach((btn) => {
    btn.addEventListener("mousemove", (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        gsap.to(btn, {
            x: x * 0.3,
            y: (y * 0.3) - 5, // Combined magnetic + lift
            scale: 1.05,
            duration: 0.3,
            ease: "power2.out",
        });
    });

    btn.addEventListener("mouseleave", () => {
        gsap.to(btn, {
            x: 0,
            y: 0,
            scale: 1,
            duration: 0.5,
            ease: "elastic.out(1, 0.3)",
        });
    });
});


// Testimonials Marquee
const testimonialTrack = document.querySelector(".testimonials-track");
if (testimonialTrack) {
    const marqueeTween = gsap.to(testimonialTrack, {
        xPercent: -50,
        repeat: -1,
        duration: 60, // Slower for reading
        ease: "linear",
    });

    testimonialTrack.addEventListener("mouseenter", () => marqueeTween.pause());
    testimonialTrack.addEventListener("mouseleave", () => marqueeTween.play());
}


// FAQ Accordion
const details = document.querySelectorAll("details");
details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
        // Close others
        details.forEach((detail) => {
            if (detail !== targetDetail && detail.hasAttribute("open")) {
                detail.removeAttribute("open");
            }
        });
    });
});




/* --- SHOP MODAL & DATA LOGIC --- */

const productsData = {
    "tshirt-femme": {
        title: "T-shirt Femme Relaxed",
        price: "29,00 €",
        description: "Une coupe décontractée et féminine. Fabriqué à partir de 100% coton biologique filé et peigné. Doux au toucher et respectueux de votre peau et de l'environnement.",
        colors: [
            { id: "navy", name: "Bleu Marine", hex: "#1e293b" },
            { id: "black", name: "Noir Profond", hex: "#000000" }
        ],
        images: {
            "navy": [
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/womens-relaxed-t-shirt-navy-front-6725181417351.jpg?v=103182833951511597881772482544",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/womens-relaxed-t-shirt-navy-front-6725181417351%20(1).jpg?v=103182833951511597881772482541",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/womens-relaxed-t-shirt-navy-front-6725181417351%20(2).jpg?v=103182833951511597881772482542"
            ],
            "black": [
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-black-front-6765654d64007.jpg?v=82072150917912462081772482526",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-black-back-2-6765654d65343.jpg?v=40770393032712820531772482521",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-black-zoomed-in-2-6765654d64b84.jpg?v=82672104608713164051772482527"
            ]
        }
    },
    "tshirt-homme": {
        title: "T-shirt Homme Bio",
        price: "29,00 €",
        description: "L'iconique t-shirt unisexe. Coupe normale, col rond. Composé à 100% de coton biologique filé à l'anneau. Un grammage de 180 g/m² pour une tenue parfaite.",
        colors: [
            { id: "black", name: "Noir Profond", hex: "#000000" },
            { id: "white", name: "Blanc Pur", hex: "#ffffff" }
        ],
        images: {
            "black": [
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-black-front-6765654d63605.jpg?v=127159334256458045341772482524",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-black-back-67251a1eccb5b.jpg?v=157443557061964479301772482523",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-black-zoomed-in-6765654d6238d.jpg?v=117435621961037920641772482529"
            ],
            "white": [
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-white-front-665e513b047a0.jpg?v=11926506147824628621772482531",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-white-right-front-665e513b07293.jpg?v=143421643539600678821772482535",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/unisex-organic-cotton-t-shirt-white-right-665e513b068c1.jpg?v=46022836213735095091772482533"
            ]
        }
    },
    "tablier": {
        title: "Tablier Chef Bio",
        price: "35,00 €",
        description: "Cuisinez avec style (et sans vous tâcher). 100% coton biologique, grammage lourd pour une protection optimale. Poche avant pratique.",
        colors: [
            { id: "black", name: "Noir Charbon", hex: "#1f1f1f" },
            { id: "red", name: "Rouge Piment", hex: "#dc2626" }
        ],
        images: {
            "black": [
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/organic-cotton-apron-black-front-6709655e5f0f6.jpg?v=4289860763835608361772482507",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/organic-cotton-apron-black-front-2-6709655e6125e.jpg?v=130940012211113374871772482505",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/organic-cotton-apron-black-zoomed-in-6709655e6158d.jpg?v=125595613918581447441772482508"
            ],
            "red": [
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/organic-cotton-apron-red-front-6709655e619f2.jpg?v=164519008020058429091772482510",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/organic-cotton-apron-red-left-front-6709655e61b5d.jpg?v=3550039606767164811772482512",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/organic-cotton-apron-red-zoomed-in-6709655e613a5.jpg?v=35243097669340890561772482514"
            ]
        }
    },
    "tote-bag": {
        title: "Tote Bag Nutrition Heureuse",
        price: "15,00 €",
        description: "Le compagnon idéal pour vos courses ou vos cours. Robuste, spacieux et écologique. Imprimé avec des encres à l'eau.",
        colors: [
            { id: "black", name: "Noir Classique", hex: "#000000" }
        ],
        images: {
            "black": [
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/eco-tote-bag-black-front-6724f9262967b.jpg?v=78816307697887426561772482499",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/eco-tote-bag-black-front-6724f92629791.jpg?v=141447546629671939001772482501",
                "//www.nutritionheureuse.com/cdn/shop/t/8/assets/eco-tote-bag-black-product-details-67096863c54cf.jpg?v=157059814962934620871772482503"
            ]
        }
    }
};

document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById("productModal");
    if (!modal) return;

    const closeModalBtn = document.getElementById("closeModalBtn");
    const closeModalBackdrop = document.getElementById("closeModalBackdrop");
    const triggers = document.querySelectorAll(".trigger-product-modal");

    // Elements to update
    const mainImage = document.getElementById("modalMainImage");
    const thumbnailsTrack = document.getElementById("modalThumbnails");
    const modalTitle = document.getElementById("modalTitle");
    const modalPrice = document.getElementById("modalPrice");
    const modalDescription = document.getElementById("modalDescription");
    const modalColors = document.getElementById("modalColors");

    let currentProduct = null;
    let currentColorId = null;

    // --- Functions ---

    function openModal(productId) {
        currentProduct = productsData[productId];
        if (!currentProduct) return;

        // Reset state (default to first color)
        currentColorId = currentProduct.colors[0].id;

        // Fill Info
        modalTitle.innerText = currentProduct.title;
        modalPrice.innerText = currentProduct.price;
        modalDescription.innerHTML = `<p>${currentProduct.description}</p>`;

        // Render Colors
        renderColors();

        // Render Images (based on current color)
        renderImages();

        // Show Modal
        modal.classList.add("open");
        document.body.classList.add("no-scroll");
    }

    function closeModal() {
        modal.classList.remove("open");
        document.body.classList.remove("no-scroll");
    }

    function renderColors() {
        modalColors.innerHTML = ""; // Clear

        if (currentProduct.colors.length <= 1) {
            document.getElementById("colorOptionGroup").style.display = "none";
        } else {
            document.getElementById("colorOptionGroup").style.display = "flex";
        }

        const colorLabel = document.querySelector("#colorOptionGroup .option-label");
        const originalLabelText = "Couleurs";

        // Reset Label
        colorLabel.innerText = `${originalLabelText}: ${currentProduct.colors.find(c => c.id === currentColorId).name}`;

        currentProduct.colors.forEach(color => {
            const swatch = document.createElement("div");
            swatch.classList.add("swatch");
            swatch.style.backgroundColor = color.hex;
            if (color.id === "white") swatch.style.border = "1px solid #ccc";

            if (color.id === currentColorId) swatch.classList.add("active");

            // Valid Click
            swatch.addEventListener("click", () => {
                currentColorId = color.id;
                renderColors(); // Re-render for active state
                renderImages(); // Switch images
            });

            // Hover for Name
            swatch.addEventListener("mouseenter", () => {
                colorLabel.innerText = `${originalLabelText}: ${color.name}`;
            });

            swatch.addEventListener("mouseleave", () => {
                // Reset to selected color
                const selectedColorName = currentProduct.colors.find(c => c.id === currentColorId).name;
                colorLabel.innerText = `${originalLabelText}: ${selectedColorName}`;
            });

            modalColors.appendChild(swatch);
        });
    }

    function renderImages() {
        const imagesList = currentProduct.images[currentColorId];

        // 1. Set Main Image (First one)
        mainImage.src = imagesList[0];
        mainImage.style.opacity = 0;
        setTimeout(() => mainImage.style.opacity = 1, 50); // Fade in

        // 2. Render Thumbnails
        thumbnailsTrack.innerHTML = "";
        imagesList.forEach((imgSrc, index) => {
            const thumb = document.createElement("img");
            thumb.src = imgSrc;
            thumb.classList.add("thumb-img");
            if (index === 0) thumb.classList.add("active");

            thumb.addEventListener("click", () => {
                // Update Main
                mainImage.style.opacity = 0;
                setTimeout(() => {
                    mainImage.src = imgSrc;
                    mainImage.style.opacity = 1;
                }, 150);

                // Update Active Thumb
                document.querySelectorAll(".thumb-img").forEach(t => t.classList.remove("active"));
                thumb.classList.add("active");
            });

            thumbnailsTrack.appendChild(thumb);
        });
    }

    // --- Event Listeners ---
    triggers.forEach(trigger => {
        trigger.addEventListener("click", (e) => {
            // Prevent if click is on button but wrapper handles it? 
            // In HTML we made whole card clickable, but also button inside. 
            // If button is clicked, it bubbles up, which is fine.
            const id = trigger.getAttribute("data-id");
            openModal(id);
        });
    });

    closeModalBtn.addEventListener("click", closeModal);
    closeModalBackdrop.addEventListener("click", closeModal);

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && modal.classList.contains("open")) closeModal();
    });
});

// 12. STICKY PRICE BAR (Scroll Trigger)
document.addEventListener('DOMContentLoaded', () => {
    const heroSection = document.querySelector('.ebook-hero, .program-hero');
    const stickyBar = document.getElementById('stickyPriceBar');

    if (heroSection && stickyBar) {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                stickyBar.classList.add('visible');
            } else {
                stickyBar.classList.remove('visible');
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        // Initial check
        handleScroll();
    }
});
// Logic moved to dynamic sections (main-ebook-v2.liquid)

// Logic moved to dynamic sections (main-programmes-v2.liquid)

// ==========================================
// BOUTIQUE PAGE FILTERING LOGIC
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
    const boutiqueGrid = document.getElementById('boutiqueGrid');
    if (!boutiqueGrid) return;

    const productCards = document.querySelectorAll('.boutique-product-card');
    const categoryBtns = document.querySelectorAll('.category-btn');
    const highlightBtns = document.querySelectorAll('.highlight-btn');
    const emptyState = document.getElementById('boutiqueEmptyState');
    const resetFiltersBtn = document.querySelector('.reset-filters-btn');

    let currentCategory = 'all';
    let currentHighlight = 'all'; // Initial default

    function filterProducts() {
        let visibleCount = 0;

        productCards.forEach(card => {
            const cardCategory = card.dataset.category;
            const cardHighlights = card.dataset.highlight ? card.dataset.highlight.split(' ') : [];

            const matchesCategory = currentCategory === 'all' || cardCategory === currentCategory;
            const matchesHighlight = currentHighlight === 'all' || cardHighlights.includes(currentHighlight);

            if (matchesCategory && matchesHighlight) {
                card.classList.remove('hidden');
                visibleCount++;
            } else {
                card.classList.add('hidden');
            }
        });

        if (visibleCount === 0) {
            if (emptyState) emptyState.style.display = 'flex';
        } else {
            if (emptyState) emptyState.style.display = 'none';
        }
    }

    // Category Buttons
    categoryBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            categoryBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            currentCategory = btn.dataset.category;
            filterProducts();
        });
    });

    // Highlight (Hero) Buttons
    highlightBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            if (btn.classList.contains('active')) {
                // Clicking active button toggles it off
                btn.classList.remove('active');
                currentHighlight = 'all';
            } else {
                highlightBtns.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                currentHighlight = btn.dataset.filter;
            }
            filterProducts();
        });
    });

    // Reset Button (in Empty State)
    if (resetFiltersBtn) {
        resetFiltersBtn.addEventListener('click', () => {
            currentCategory = 'all';
            currentHighlight = 'all';
            
            categoryBtns.forEach(b => b.classList.remove('active'));
            document.querySelector('.category-btn[data-category="all"]')?.classList.add('active');
            
            highlightBtns.forEach(b => b.classList.remove('active'));

            filterProducts();
        });
    }

    // Run initial filter on load
    filterProducts();
});

// ==========================================
// GLOBAL AJAX CART INTERCEPTOR (V2)
// ==========================================
document.addEventListener('click', (e) => {
    const cartLink = e.target.closest('a[href*="/cart/add"]');
    if (!cartLink) return;

    // Skip if it's already being handled by a form (like in main-boutique-v2)
    if (cartLink.closest('form')) return;

    e.preventDefault();

    const url = new URL(cartLink.href, window.location.origin);
    const variantId = url.searchParams.get('id');
    const quantity = url.searchParams.get('quantity') || 1;

    if (!variantId || variantId === "" || variantId === "null") {
        console.error('Cart Interceptor: Missing or invalid variant ID');
        return;
    }

    // Add loading state to button if possible
    const originalText = cartLink.innerHTML;
    cartLink.innerHTML = '<span class="loading-spinner"></span>';
    cartLink.style.pointerEvents = 'none';

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: parseInt(quantity)
            }]
        })
    })
    .then(response => response.json())
    .then(data => {
        // Reset button
        cartLink.innerHTML = originalText;
        cartLink.style.pointerEvents = '';

        if (data.status === 422 || data.message === "Cart Error") {
            alert("Une erreur est survenue lors de l'ajout au panier. Vérifiez si le produit est disponible.");
        } else {
            // Trigger drawer refresh on documentElement
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            // Open drawer
            if (typeof openCartDrawer === 'function') {
                openCartDrawer();
            } else {
                const drawerToggle = document.getElementById('cart-drawer-toggle');
                if (drawerToggle) drawerToggle.checked = true;
            }
        }
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
        cartLink.innerHTML = originalText;
        cartLink.style.pointerEvents = '';
    });
});

// ==========================================
// COMING SOON MODAL LOGIC
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('comingSoonModal');
    if (!modal) return;

    const closeBtn = modal.querySelector('.nh-modal-close');

    const openModal = () => {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        modal.classList.remove('active');
        document.body.style.overflow = '';
    };

    const openBtns = document.querySelectorAll('.open-coming-soon');
    const hiddenTagInput = document.querySelector('#comingSoonForm input[name="contact[tags]"]');

    openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const handle = btn.getAttribute('data-handle');
            if (handle && hiddenTagInput) {
                // Combine default tags and dynamic product tag
                hiddenTagInput.value = `newsletter, coming-soon, coming-soon-${handle}`;
            } else if (hiddenTagInput) {
                hiddenTagInput.value = `newsletter, coming-soon`;
            }
            openModal();
        });
    });

    closeBtn?.addEventListener('click', closeModal);

    modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('active')) closeModal();
    });

    // Auto-open if redirected back with a success/error anchor
    if (window.location.hash.includes('contact_form')) {
        openModal();
    }

    // Form Submission Visual Feedback (Native Shopify Submit)
    const form = document.getElementById('comingSoonForm');
    if (form) {
        form.addEventListener('submit', () => {
            const submitBtn = form.querySelector('.nh-modal-submit');
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Envoi...';
            }
        });
    }
});
